import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export function Markdown({ children, className = "" }) {
  return (
    <div className={`md-body ${className}`}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          h1: (p) => <h1 className="font-serif text-2xl mt-4 mb-2" {...p} />,
          h2: (p) => <h2 className="font-serif text-xl mt-4 mb-2" {...p} />,
          h3: (p) => <h3 className="font-serif text-lg mt-3 mb-1.5" {...p} />,
          p: (p) => <p className="mb-3 leading-relaxed" {...p} />,
          ul: (p) => <ul className="list-disc pl-5 mb-3 space-y-1" {...p} />,
          ol: (p) => <ol className="list-decimal pl-5 mb-3 space-y-1" {...p} />,
          li: (p) => <li className="leading-relaxed" {...p} />,
          a: (p) => <a className="text-gold underline hover:text-gold-hover" target="_blank" rel="noreferrer" {...p} />,
          strong: (p) => <strong className="font-semibold text-foreground" {...p} />,
          blockquote: (p) => <blockquote className="border-l-2 border-gold pl-4 italic text-muted-foreground my-3" {...p} />,
          code: ({ node, className, children, ...p }) => {
            const text = String(children ?? "");
            const isBlock = className?.includes("language-") || text.includes("\n");
            return isBlock ? (
              <code className={`block font-mono text-[0.85em] ${className || ""}`} {...p}>{children}</code>
            ) : (
              <code className="font-mono text-[0.85em] bg-secondary px-1.5 py-0.5" {...p}>{children}</code>
            );
          },
          pre: (p) => <pre className="bg-secondary border border-border p-3 overflow-x-auto my-3 text-[0.85em]" {...p} />,
          hr: () => <div className="gold-rule my-4" />,
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
